var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mb-5",attrs:{"outlined":"","color":"white"}},[_c('v-breadcrumbs',{attrs:{"items":_vm.items,"large":""}})],1),_c('div',[_c('v-img',{attrs:{"src":_vm.getIMG(_vm.imgurl)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }